import { ProjectSchema, WorkExpSchema } from '@shaojiang/types/profile';

import projectsJson from './projects.json';
import workExperienceJson from './workExperience.json';

/**
 * Typed, validated profile data. Parsing at module load means a malformed edit to the JSON
 * fails the build (and tests) with a readable zod error instead of rendering broken UI.
 */
export const projects = ProjectSchema.array().parse(projectsJson);
export const workExperience = WorkExpSchema.array().parse(workExperienceJson);

export const findProjectBySlug = (slug: string) => projects.find((p) => p.slug === slug) ?? null;
export const findProjectByName = (name: string) => projects.find((p) => p.name === name) ?? null;
